@let items = (pools$ | async) ?? [];

<lib-multiselect
  titleTranslationKey="monitoring.pool"
  chosenTranslationKey="monitoring.pools-chosen"
  [options]="items"
  [formControl]="controlEntity"
  [isSearchDisplayed]="true"
  [isLazyLoading]="poolDictionaryService.isLoading()"
  (shouldLoadMoreOptions)="loadMore()"
  (keywordChange)="onKeywordChange($event)"
/>
